import { Component, OnInit } from '@angular/core';
import { LiteratureService } from '../../../core/services/literature.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-lierature-pages',
  templateUrl: './lierature-pages.component.html',
  styleUrls: ['./lierature-pages.component.scss']
})
export class LieraturePagesComponent implements OnInit {
  documentScreensList: any;
  docTypeId: string = "";
  heading: string = "";
  constructor(private literatureService: LiteratureService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.docTypeId = params.id;
    });
    this.loadLiteratureDocumentGroup(this.docTypeId);
  }

  //#region load details
  loadLiteratureDocumentGroup(docTypeId) {
    const body = {
      docTypeID: parseInt(docTypeId)
    }
    this.literatureService.getLieratureDocumentsPages(body).subscribe((response) => {
      console.log(response);
      if (response) {
        this.heading = response[0].docTypeDescription;
        this.documentScreensList = response;
      }
    });
  }
  //#endregion
}
